export default __webpack_public_path__ + "static/media/segurnosti.4a56e69f.jpeg";